<template>
  <el-dialog :title="$t('signedDocument')" :visible="isShowDialog" @close="onClosePopupButtonClick()" width="700px;">
    <el-container>
      <el-main>
        <div v-loading="isLoading">
          <div>
            <table class="table-signed-document" border="0" cellspacing="0" cellpadding="0">
              <tr v-for="(signedDocument, index) in signedDocumentPerPageList"
                  :key="`${index}`"
              :class="{'latest-file':(index === 0 && currentPage === 1)}">
                <td width="60%">
                  <div class="signed-document-default"
                       style="float: left; margin-top: 5px; margin-right: 10px"></div>
                  <div style="float: left;">{{ getDocumentName(signedDocument.name) }}</div>
                </td>
                <td width="20%">{{getCreatedAt(signedDocument.createdAt)}}</td>
                <td width="20%" align="right">
                  <el-button type="primary"
                             size="small"
                             @click="onDownloadButtonClick(signedDocument)">
                    {{$t('download')}}
                  </el-button></td>
              </tr>
            </table>
          </div>
          <div>
            <el-pagination
              background
              layout="prev, pager, next"
              :total="signedDocumentList.length"
              :page-size="pageSize"
              :current-page="currentPage"
              @current-change = "changePage">
            </el-pagination>
          </div>
        </div>
        <div style="margin-top: 20px">
          <h4>{{$t('addSignedDocument')}}</h4>
          <div class="upload-container">
            <el-row>
              <el-col :span="20">
                <input-file-component v-model="fileUploadData"
                                      :size="'small'"></input-file-component>
              </el-col>
              <el-col :span="4">
                <el-button type="primary"
                           size="small"
                           :disabled="isDisabledUpload()"
                           icon="el-icon-upload"
                           @click="onUploadButtonClick()">
                  {{$t('upload')}}
                </el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-main>
    </el-container>
  </el-dialog>
</template>

<script>
import i18nMessages from '@/translations/Contract/components/PopupSignedDocumentList.i18n'
import ContractApi from '@/api/contract-api'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import { get, cloneDeep } from 'lodash'
import { getDataOnPaging, adjustCurrentPage } from '@/services/general-service'
import { dateFormat } from '@/helpers/datetime'
import { forceDownloadFileUrl } from '@/helpers'
import InputFileComponent from '@/components/InputFileComponent'
export default {
  name: 'PopupSignedDocumentComponent',
  components: { InputFileComponent },
  i18n: { messages: i18nMessages },
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    contractId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      signedDocumentList: [],
      signedDocumentPerPageList: [],
      isShowDialog: false,
      currentPage: 1,
      pageSize: 5,
      isLoading: true,
      fileUploadData: {}
    }
  },
  watch: {
    visible: function (newValue) {
      this.isShowDialog = newValue
      this.initData()
    }
  },
  methods: {
    initData: async function () {
      this.isLoading = true
      try {
        const result = await ContractApi.detail(this.contractId)
        const signedDocumentList = get(result.contractDetail, 'signedDocumentList', [])
        this.signedDocumentList = this._sortByCreatedAt(signedDocumentList)
        this._prepareSignedDocumentPerPageList()
      } catch (err) {
        this.alertError(err.message)
      }
      this.isLoading = false
    },
    onClosePopupButtonClick: function () {
      this._closePopup()
    },
    changePage: function (page) {
      this.currentPage = page
      this._prepareSignedDocumentPerPageList()
    },
    getCreatedAt: function (unixTime) {
      const createdAt = new Date(unixTime * 1000)

      return dateFormat.short(createdAt)
    },
    onUploadButtonClick: async function () {
      this.startLoading()
      try {
        const data = {
          fileUpload: this.fileUploadData
        }
        const result = await ContractApi.uploadSignedDocument(this.contractId, data)
        this.signedDocumentList = result.signedDocumentList
        this._prepareSignedDocumentPerPageList()

        const title = this.$t('success')
        const message = this.$t('uploadSuccessMessage')
        this.showNotificationSuccess(title, message)

        this.$emit('onUploaded', this.contractId)

        this.fileUploadData = {}
      } catch (err) {
        this.alertError(err.message)
      }
      this.stopLoading()
    },
    onDownloadButtonClick: async function (signedDocument) {
      this.startLoading()
      try {
        const data = {
          fileUrl: signedDocument.url
        }
        const documentResult = await ContractApi.downloadSignedDocument(data)
        const documentData = `data:${signedDocument.mimeType}; base64, ${documentResult}`
        forceDownloadFileUrl(documentData, signedDocument.name)
      } catch (err) {
        this.alertError(err.message)
      }
      this.stopLoading()
    },
    isDisabledUpload: function () {
      const fileName = get(this.fileUploadData, 'name', '')
      const content = get(this.fileUploadData, 'content', '')
      if (fileName === '' || content === '') {
        return true
      }

      return false
    },
    getDocumentName: function (name) {
      if (name.length > 40) {
        return `${name.substring(0, 36)}...`
      }

      return name
    },
    _prepareSignedDocumentPerPageList: function () {
      this.currentPage = adjustCurrentPage(this.signedDocumentList.length, this.currentPage, this.pageSize)
      const tempList = cloneDeep(this.signedDocumentList)
      this.signedDocumentPerPageList = getDataOnPaging(tempList, this.currentPage, this.pageSize)
    },
    _closePopup: function () {
      this.isShowDialog = false
      this.currentPage = 1
      this.signedDocumentList = []
      this.signedDocumentPerPageList = []
      this.$emit('onClose')
    },
    _sortByCreatedAt: function (singedDocumentList) {
      const result = singedDocumentList.sort((a, b) => {
        return (a.createdAt > b.createdAt) ? -1 : 1
      })

      return result
    }
  }
}
</script>
<style scoped>
  .table-signed-document {
    width: 100%;
    margin-bottom: 22px;
  }

  .table-signed-document td {
    padding: 10px;
    border-bottom: 1px #ddd solid;
    font-size: 14px;
  }
  .upload-container {
    border: solid 1px #409EFF;
    border-radius: 15px;
    padding: 20px;
  }
  .latest-file {
    font-weight: 600;
  }
  div.btn-upload {
    overflow: hidden;
    text-align: center;
    position: relative;
    margin: 0px;
    float: left;
    transition: all ease 0.2s;
    width: 100%;
    text-align: left;
  }

  input.upload {
    bottom: 0px;
    right: 0px;
    opacity: 0;
    width: 100%;
    height: 100%;
    outline: none;
    cursor: pointer;
    position: absolute;
    z-index: 100;
  }
</style>
